import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "datepicker-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "input-label mb-3" }, [
  /*#__PURE__*/_createTextVNode("Wybierz badanie "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-error" }, "*")
], -1)
const _hoisted_3 = { class: "w-full md:max-w-[332px]" }
const _hoisted_4 = {
  key: 0,
  class: "error-message"
}

import { computed } from 'vue';
import { useField } from 'vee-validate';
import Select from '../../ui/Select.vue';
import WeekOfPregnatField from './WeekOfPregnatField.vue';
import ImportantInformationField from './ImportantInformationField.vue';
import IndicationsForPrenatalTesting from './IndicationsForPrenatalTesting.vue';
import UploadPrenatalDocumentation from './UploadPrenatalDocumentation.vue';
import WhichPregnancyFieldVue from './WhichPregnancyField.vue';
import WhichBirthFieldVue from './WhichBirthField.vue';


export default {
  __name: 'SelectPrenatalTesting',
  setup(__props) {

const { value, setValue, errorMessage } = useField('prenatalTesting');

const options = [
    {
        id: 'USG 11 - 14 TYDZIEŃ CIĄŻY',
        title: 'USG 11 - 14 TYDZIEŃ CIĄŻY',
    },
    {
        id: 'USG 20 - 24 TYDZIEŃ CIĄŻY',
        title: 'USG 20 - 24 TYDZIEŃ CIĄŻY',
    },
    {
        id: 'TEST ZŁOŻONY PAPPA',
        title: 'TEST ZŁOŻONY PAPPA',
    },
    {
        id: 'KONSULTACJA W POR. GENETYCZNEJ',
        title: 'KONSULTACJA W POR. GENETYCZNEJ',
    },
    {
        id: 'BIOPSJA TROFOBLASTU',
        title: 'BIOPSJA TROFOBLASTU',
    },
    {
        id: 'AMNIOPUNKCJA',
        title: 'AMNIOPUNKCJA',
    },
];

const canRenderOtherFields = computed(() => {
    return (
        value.value === 'KONSULTACJA W POR. GENETYCZNEJ' ||
        value.value === 'BIOPSJA TROFOBLASTU' ||
        value.value === 'AMNIOPUNKCJA'
    );
});

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(Select, {
          options: options,
          selected: _unref(value),
          onOnChange: _unref(setValue)
        }, null, 8, ["selected", "onOnChange"])
      ]),
      (_unref(errorMessage))
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_unref(errorMessage)), 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode(WeekOfPregnatField),
    _createVNode(WhichPregnancyFieldVue),
    _createVNode(WhichBirthFieldVue),
    (_unref(canRenderOtherFields))
      ? (_openBlock(), _createBlock(IndicationsForPrenatalTesting, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(UploadPrenatalDocumentation),
    (_unref(canRenderOtherFields))
      ? (_openBlock(), _createBlock(ImportantInformationField, {
          key: 1,
          title: "Dodatkowe informacje dla Iekarza",
          placeholder: "",
          classes: "md:!min-h-[200px]",
          isRequired: false
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

}